import { Component, OnDestroy, OnInit } from "@angular/core";
import { TransitionService, UIRouterGlobals, AnchorUISref, UISref } from "@uirouter/angular";
import { StateParams } from "@uirouter/core/lib/params/stateParams";
import { BreadcrumbService, IBreadcrumb } from "./breadcrumb.service";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "breadcrumb",
    templateUrl: "./breadcrumb.component.html",
    imports: [
        NgClass,
        AnchorUISref,
        UISref,
        TranslatePipe,
    ],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

    private deregisterStateChange: () => void;

    public constructor(
        private readonly breadcrumbService: BreadcrumbService,
        private readonly uiRouterGlobals: UIRouterGlobals,
        private readonly transitionService: TransitionService,
    ) {
    }

    public ngOnInit(): void {
        // uirouter types its deregistration callback as the bare Function, which no-unsafe-function-type rejects.
        this.deregisterStateChange = this.transitionService.onSuccess({ to: "**" }, () => this.breadcrumbService.stateChangeListener()) as () => void;
        this.breadcrumbService.stateChangeListener();
    }

    public get breadcrumbs(): IBreadcrumb[] {
        return this.breadcrumbService.breadcrumbs;
    }

    public getStateName(state: IBreadcrumb): string {
        if (!state.url) {
            return "";
        }
        return state.name!;
    }

    public getStateParams(): StateParams {
        return this.uiRouterGlobals.params;
    }

    public identify(index: number): number {
        return index;
    }

    public ngOnDestroy(): void {
        this.deregisterStateChange();
    }
}
